import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "quoteleft" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_6 = { width: "30%" }
const _hoisted_7 = { align: "right" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_11 = { width: "30%" }
const _hoisted_12 = { align: "right" }
const _hoisted_13 = ["id", "value"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  key: 1,
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_16 = { width: "30%" }
const _hoisted_17 = { align: "right" }
const _hoisted_18 = { style: {"text-align":"center"} }

import QuoteCart from "@/views/quote/QuoteCart.vue";
import HelpPopup from "@/components/HelpPopup.vue";
import { scrollMeTo, stat } from "@/utils/Utils";
import { NssiData } from "@/api/NssiData";
import { PaymentOptions } from "@/models/QuoteInsurance";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import ProductService from "@/services/ProductService";
import { inject, onMounted, ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useStatusStore } from "@/stores/root/status";
import { useProductStore } from "@/stores/root/products";
import { watch } from "vue";

const title = "Add-On";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteAddon',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;
const quote = useQuoteStore();
const productStore = useProductStore();
const loading: Ref<boolean> = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const nssiCoverages: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const inj = inject("$emitter");
const options = ref<any[]>([]);
const selectedCoverage = ref();
const showDec = ref(false);
const ratingType = ref("");
const policyTermsArray = ref<any[]>([]);
const coverageTypes = ref<any[]>([]);

const getCoverages = async () => {
  try {
    const products = await ProductService.all();
    if (products[0].rating_type) ratingType.value = products[0].rating_type;
    console.log("Products:", products[0]);
    nssiCoverages.value.push(products[0].coverage_amounts);
    options.value = products[0].coverage_amounts ?? [];
    console.log(options.value);
  } catch (error) {
    throw "Products load error";
  }
};

onMounted(() => {
  getCoverages();

  if (
    productStore &&
    productStore.products[0] &&
    productStore.products[0].coverage_amounts
  ) {
    console.log("Product", productStore.products[0].coverage_amounts);
    selectedCoverage.value = productStore.products[0].coverage_amounts.find(
      function (item) {
        return (
          Number(item.value) === Number(quote.personalInsurance.coverageAmount)
        );
      }
    );
    console.log("selectedCoverage:", selectedCoverage.value);
    //showDec.value = true;
  }
});

const validated = computed(() => {
  const personalValidate =
    quote.personalInsurance.coverageAmount > 0 &&
    quote.personalInsurance.deductibleAmount &&
    quote.personalInsurance.paymentOption;

  return quote.hasPersonalInsurance ? personalValidate : true;
});
watch(
  function () {
    return quote.personalInsurance.coverageAmount;
  },
  function (newValue) {
    selectedCoverage.value = options.value.find(function (item) {
      return item.value === newValue;
    });
    quote.personalInsurance.deductibleAmount = 0;
    quote.personalInsurance.paymentOption = PaymentOptions.None;
    policyTermsArray.value = selectedCoverage.value
      ? selectedCoverage.value.policy_terms
      : [];
    coverageTypes.value = selectedCoverage.value
      ? selectedCoverage.value.coverage_types
      : [];
    if (selectedCoverage.value && selectedCoverage.value.deductibles) {
      showDec.value = true;
    }
    console.log("changedCoverage:", selectedCoverage.value);
  }
);
watch(
  function () {
    return quote.personalInsurance.deductibleAmount;
  },
  function (newValue) {
    quote.personalInsurance.deductibleAmountText = nssiDeductibles.value.find(
      function (item: any) {
        return item.value === newValue;
      }
    )?.text;
    // quote.personalInsurance.deductibleAmount = 0;
    // quote.personalInsurance.paymentOption = PaymentOptions.None;
    // if (selectedCoverage.value && selectedCoverage.value.deductibles) {
    //   showDec.value = true;
    // }
    console.log("dec", quote.personalInsurance.deductibleAmountText);
    console.log("changed:", newValue);
  }
);

function createValidationMessages(): void {
  validationErrors.value.length = 0;

  if (!(quote.personalInsurance.coverageAmount > 0)) {
    const error = {
      name: "coverageAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.deductibleAmount > 0)) {
    const error = {
      name: "personalDeductible",
      value: "Deductible is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.paymentOption > 0)) {
    const error = {
      name: "personalLiabilityPaymentPlan",
      value: "Payment option is required.",
    };
    validationErrors.value.push(error);
  }
}

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  quote.setQuoteStep(command);
}

const readNssiRates = async () => {
  const ratesResult = await NssiData.getRates(quote);
  if (ratesResult.error) {
    stat(statusStore).error(ratesResult.message);
    scrollMeTo("status");
  } else {
    if (ratesResult.result.rates && ratesResult.result.rates[0]) {
      const rate = ratesResult.result.rates[0];
      console.log("RATE", rate);
      console.log("PaymentOptions", PaymentOptions);
      quote.personalInsurance.annualAmount = rate.full_term_premium;
      quote.personalInsurance.monthlyAmount = rate.installment_premium;
      quote.personalInsurance.installmentAmount = rate.installment_premium;
      quote.monthlyProcessingFee = rate.installment_proc_fee;
      quote.processingFee = rate.full_term_proc_fee;
      quote.personalInsurance.monthlyProcessingFee = rate.installment_proc_fee;
      quote.personalInsurance.fullTermTotal = rate.full_term_total;
      quote.personalInsurance.installmentTotal = rate.installment_total;
      quote.personalInsurance.processingFee = rate.full_term_proc_fee;
      quote.personalInsurance.discount = rate.discount;
      quote.personalInsurance.installmentDiscount = rate.installment_discount;
      quote.personalInsurance.policyTerms = policyTermsArray.value;
      quote.personalInsurance.coverageTypes = coverageTypes.value;
      quote.personalInsurance.sku = rate.SKU;
      quote.personalInsurance.term = rate.term;
      quote.personalInsurance.processingFeeSku =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.ProcessingFeeSKU_Installment
          : rate.ProcessingFeeSKU;
      quote.personalInsurance.dueToday =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.installment_total
          : rate.full_term_total;
      quote.personalInsurance.retailPremium =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.installment_total
          : rate.full_term_total;
    }
  }
};

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  if (!event || !event.target || !event.target.name) {
    return;
  }
  clearValidationMessage(event.target.name);
}

const quoteChange = async (event: any) => {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
};

const nssiQuoteChange = async (event: any) => {
  if (
    quote.hasPersonalInsurance &&
    quote.personalInsurance.coverageAmount &&
    quote.personalInsurance.deductibleAmount
  ) {
    loading.value = true;
    stat(statusStore).clear();
    await readNssiRates();
    loading.value = false;
    quote.showAddonOnCart = true;
  }
  quoteChange(event);
};

const nssiDeductibles: ComputedRef<any> = computed(() => {
  return selectedCoverage.value && selectedCoverage.value.deductibles
    ? selectedCoverage.value.deductibles
    : [];
  //return NssiData.deductibles;
});

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "Personal Property Add-On", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "poweredby" }, "Provided by NSSI", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
        _createVNode(StatusComponent),
        _withDirectives(_createElementVNode("input", {
          id: "addpp",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(quote).hasPersonalInsurance) = $event)),
          type: "checkbox",
          class: "styledchecked",
          name: "liability-ded",
          "true-value": true,
          onChange: nssiQuoteChange
        }, null, 544), [
          [_vModelCheckbox, _unref(quote).hasPersonalInsurance]
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("label", {
          for: "addpp",
          class: "subtitle",
          style: {"color":"#414142"}
        }, " Add Accidental Damage Coverage ", -1)),
        _createVNode(HelpPopup, { msg: "Covers your phone, laptop, camera, headphones --- from accidental drops, cracked screens or liquid damage." }),
        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
        (_unref(quote).hasPersonalInsurance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_6, [
                      _cache[6] || (_cache[6] = _createElementVNode("strong", { class: "subsubtitle" }, "Coverage", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("red", null, "*", -1)),
                      _createVNode(HelpPopup, {
                        msg: "The maximum payout per claim.",
                        "help-class": "help smallhelp"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_7, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).personalInsurance.coverageAmount) = $event)),
                        style: {"width":"60%"},
                        name: "coverageAmount",
                        class: _normalizeClass({ validationfield: hasErrors('coverageAmount') }),
                        disabled: !nssiCoverages.value[0],
                        onChange: nssiQuoteChange
                      }, [
                        _cache[8] || (_cache[8] = _createElementVNode("option", { value: "0" }, "Please Select...", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiCoverages.value[0], (coverage) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: coverage.value,
                            value: coverage.value
                          }, _toDisplayString(coverage.text), 9, _hoisted_9))
                        }), 128))
                      ], 42, _hoisted_8), [
                        [_vModelSelect, _unref(quote).personalInsurance.coverageAmount]
                      ]),
                      _createVNode(ValidationError, {
                        name: "coverageAmount",
                        errors: validationErrors.value
                      }, null, 8, ["errors"])
                    ])
                  ])
                ])
              ]),
              (showDec.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_11, [
                          _cache[9] || (_cache[9] = _createElementVNode("strong", { class: "subsubtitle" }, "Deductible", -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("red", null, "*", -1)),
                          _createVNode(HelpPopup, {
                            msg: "A deductible is the amount the policyholder must pay before the insurer pays out\n                                            the claim.",
                            "help-class": "help smallhelp"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiDeductibles.value, (deductible) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              _withDirectives(_createElementVNode("input", {
                                id: 'pp-ded-' + deductible.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(quote).personalInsurance.deductibleAmount) = $event)),
                                type: "radio",
                                class: "styledradio",
                                name: "personalDeductible",
                                value: deductible.value,
                                onChange: nssiQuoteChange
                              }, null, 40, _hoisted_13), [
                                [_vModelRadio, _unref(quote).personalInsurance.deductibleAmount]
                              ]),
                              _createElementVNode("label", {
                                name: "personalDeductible",
                                for: 'pp-ded-' + deductible.value,
                                class: _normalizeClass({
                        validationfield: hasErrors('personalDeductible'),
                      }),
                                style: {"margin-left":"5px !important"},
                                onClick: validatedFieldChanged
                              }, _toDisplayString(deductible.text), 11, _hoisted_14)
                            ], 64))
                          }), 256)),
                          _createVNode(ValidationError, {
                            name: "personalDeductible",
                            errors: validationErrors.value
                          }, null, 8, ["errors"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showDec.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_16, [
                          _cache[11] || (_cache[11] = _createElementVNode("strong", { class: "subsubtitle" }, "Payment Options", -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("red", null, "*", -1)),
                          _createVNode(HelpPopup, {
                            msg: "Choose a payment plan that's best for you: monthly or annual.",
                            "help-class": "help smallhelp"
                          })
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            id: "pp-paymentplan-monthly",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(quote).personalInsurance.paymentOption) = $event)),
                            type: "radio",
                            class: "styledradio",
                            name: "personalLiabilityPaymentPlan",
                            value: 1,
                            onChange: nssiQuoteChange
                          }, null, 544), [
                            [
                              _vModelRadio,
                              _unref(quote).personalInsurance.paymentOption,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("label", {
                            name: "personalLiabilityPaymentPlan",
                            for: "pp-paymentplan-monthly",
                            class: _normalizeClass({
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }),
                            style: {"margin-left":"5px !important"},
                            onClick: validatedFieldChanged
                          }, " Monthly ", 2),
                          _withDirectives(_createElementVNode("input", {
                            id: "pp-paymentplan-annual",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(quote).personalInsurance.paymentOption) = $event)),
                            type: "radio",
                            class: "styledradio",
                            name: "personalLiabilityPaymentPlan",
                            value: 2,
                            onChange: nssiQuoteChange
                          }, null, 544), [
                            [
                              _vModelRadio,
                              _unref(quote).personalInsurance.paymentOption,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("label", {
                            name: "personalLiabilityPaymentPlan",
                            for: "pp-paymentplan-annual",
                            class: _normalizeClass({
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }),
                            style: {"margin-left":"5px !important"},
                            onClick: validatedFieldChanged
                          }, " Annual ", 2),
                          _createVNode(ValidationError, {
                            name: "personalLiabilityPaymentPlan",
                            errors: validationErrors.value
                          }, null, 8, ["errors"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "spacer" }, null, -1)),
        _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1)),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !validated.value }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage('quote-account')))
          }, " Continue ", 2)
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
        _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1))
      ]),
      _createVNode(QuoteCart)
    ])
  ]))
}
}

})